import styled from 'styled-components'

export const FaqContainer = styled.div`
  margin: 5.6rem 0;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    margin: 6.4rem auto 8rem;
    max-width: 74rem;
  }

  .accordion__title {
    font-weight: bold;
    font-family: ${props => props.theme.fonts.bold};

    h6 {
      font-size: 1.4rem;

      @media screen and (min-width: ${props => props.theme.responsive.medium}) {
        font-size: 1.6rem;
      }
    }
  }

  a.viewAllCTA {
    font-size: 1.4rem;
    display: block;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      font-size: 1.6rem;
      padding: 1.7rem 1.6rem;
      display: inline-block;
      min-width: 25.6rem;
    }
  }

  h3 {
    text-align: center;
    margin-bottom: 3rem;
    &:after {
      content: '';
      display: block;
      height: 1px;
      background-color: ${props => props.theme.colors.cobalt};
      max-width: 12.5rem;
      margin: 2rem auto 0;
      @media screen and (min-width: ${props => props.theme.responsive.small}) {
        max-width: 25rem;
      }
    }
  }
`
